import {createFeature, StoreModule} from '@ngrx/store';
import {StoreKeys} from '../../../models/store-keys';
import {wkfSupervisionSearchItemsReducer} from './reducer/wkf-supervision-search-items.reducer';

export const wkfSupervisionSearchItemStoreConfig = StoreModule.forFeature(
  createFeature({
    name: StoreKeys.WKF_SUPERVISION_SEARCH_ITEMS,
    reducer: wkfSupervisionSearchItemsReducer
  })
);
